module.exports = __webpack_public_path__ + "img/imperial-hd.1b6e900c.png";